import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { FrattaleService } from './frattale.service';

@Injectable({
  providedIn: 'root'
})
export class AsianboService extends FrattaleService {

  constructor(@Inject(HttpClient) protected http: HttpClient) { 
    super(http) 
  }

  operazioniDelGiorno(giorno: string){
    let data = {
      action: "asiabo/asiabo_bt",
      cmd: "operazioni_del_giorno",
      giorno: giorno
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  asiact_storico(mkt: string, periodo: string = '1') {
    let data = {
      action: "asiaboct",
      cmd: "storico",
      takeprofit: periodo,
      market: mkt
    }
    return this.http.post(this.url, data, { headers: this.head })
  }
}
